class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = this.tabs
      .map((tab) => document.getElementById(tab.getAttribute('aria-controls')))
      .filter(Boolean);
    this._clickHandlers = this.tabs.map((_, i) => (e) => {
      e.preventDefault();
      this.activate(i);
    });
    this._keydownHandlers = this.tabs.map((_, i) => (e) => this.onKeyDown(i, e));
  }

  connectedCallback() {
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', this._clickHandlers[i]);
      tab.addEventListener('keydown', this._keydownHandlers[i]);
    });
  }

  disconnectedCallback() {
    this.tabs.forEach((tab, i) => {
      tab.removeEventListener('click', this._clickHandlers[i]);
      tab.removeEventListener('keydown', this._keydownHandlers[i]);
    });
  }

  onKeyDown(currentIndex, event) {
    let nextIndex = currentIndex;
    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.activate(nextIndex);
    this.tabs[nextIndex].focus();
  }

  activate(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });
    this.panels.forEach((panel, i) => {
      if (!panel) return;
      const active = i === index;
      panel.classList.toggle('best-selling__panel--active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    });
  }
}

if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', CollectionTabs);
}
